export default "__VITE_ASSET__rIos3OnL__"